<!--Header-->
<div class="modal-header border-0">
  <div class="modal-title">
    <h4 class="modern-header">
      <i class="fa-solid fa-address-card me-2"></i>
      {{ modal_type }} {{ contact_type }} Contact
    </h4>
  </div>
  @if (missing_fields.length) {
    <div
      class="header-alert d-flex align-items-center"
      role="alert"
      >
      <i class="fa-solid fa-circle-exclamation me-2"></i>
      <span class="header-alert-prefix">Please fill in:</span>
      <div class="header-alert-chips">
        @for (field of missing_fields; track field) {
          <span class="header-alert-chip">{{ field }}</span>
        }
      </div>
      <button
        type="button"
        class="header-alert-close ms-2"
        aria-label="Dismiss"
        (click)="missing_fields = []"
        >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  }
  <button
    type="button"
    class="close-btn"
    (click)="closeModalClick()"
    aria-label="Close"
    >
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<form
  [formGroup]="add_edit_contact_form"
  (ngSubmit)="addEditContactClick()"
  autocomplete="off"
  >
  <div class="modal-body-scroll">
    <!-- Name and Contact Section -->
    <div class="section-card">
      <div
        class="section-header"
        (click)="nameContactIsCollapsed = !nameContactIsCollapsed"
        >
        <div class="section-title">
          <i class="fa-solid fa-user"></i>
          Name and Contact
        </div>
        <div class="toggle-icon">
          <i
            class="fa-solid"
            [ngClass]="
              nameContactIsCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'
            "
          ></i>
        </div>
      </div>
      <div [collapse]="nameContactIsCollapsed">
        <div class="section-body">
          <!-- Row 1: Title, First, Middle, Last, Suffix -->
          <div class="row mb-3">
            <div class="col-md-2 d-flex align-items-center">
              <label class="form-label me-2">Title:</label>
              <ng-select
                [items]="titles"
                [multiple]="false"
                [closeOnSelect]="true"
                appendTo="body"
                class="form-control flex-grow-1"
                formControlName="name_title"
                id="name_title"
                (change)="createDisplayedNameList()"
              ></ng-select>
            </div>
            <div class="col-md-3 d-flex align-items-center">
              <label class="form-label me-2">First:</label>
              <input
                type="text"
                class="form-control flex-grow-1"
                formControlName="name_first"
                id="name_first"
                (change)="createDisplayedNameList()"
                />
              </div>
              <div class="col-md-2 d-flex align-items-center">
                <label class="form-label me-2">Middle:</label>
                <input
                  type="text"
                  class="form-control flex-grow-1"
                  formControlName="name_middle"
                  id="name_middle"
                  (change)="createDisplayedNameList()"
                  />
                </div>
                <div class="col-md-3 d-flex align-items-center">
                  <label class="form-label me-2">Last:</label>
                  <input
                    type="text"
                    class="form-control flex-grow-1"
                    formControlName="name_last"
                    id="name_last"
                    (change)="createDisplayedNameList()"
                    />
                  </div>
                  <div class="col-md-2 d-flex align-items-center">
                    <label class="form-label me-2">Suffix:</label>
                    <input
                      type="text"
                      class="form-control flex-grow-1"
                      formControlName="name_suffix"
                      id="name_suffix"
                      (change)="createDisplayedNameList()"
                      />
                    </div>
                  </div>

                  <!-- Row 2: Company and Display Name -->
                  <div class="row mb-3">
                    <div class="col-md-6 d-flex align-items-center">
                      <label class="form-label me-3" style="width: 150px"
                        >Company Name:</label
                        >
                        <input
                          type="text"
                          class="form-control flex-grow-1"
                          formControlName="company_name"
                          id="company_name"
                          (change)="createDisplayedNameList()"
                          />
                        </div>
                        <div class="col-md-6 d-flex align-items-center">
                          <label class="form-label me-3" style="width: 150px">
                            <span class="text-danger me-1">*</span>Display Name:
                          </label>
                          <ng-select
                [items]="
                  customerDisplayNames.length > 0 ? customerDisplayNames : []
                "
                            [multiple]="false"
                            [closeOnSelect]="true"
                            appendTo="body"
                            class="form-control flex-grow-1"
                            formControlName="display_name"
                            id="display_name"
                          ></ng-select>
                        </div>
                      </div>

                      <!-- Row 3: Email and Phone -->
                      <div class="row mb-3">
                        <div class="col-md-6 d-flex align-items-center">
                          <label class="form-label me-3" style="width: 150px">Email:</label>
                          <input
                            type="email"
                            class="form-control flex-grow-1"
                            formControlName="email"
                            id="email"
                            />
                          </div>
                          <div class="col-md-6 d-flex align-items-center">
                            <label class="form-label me-3" style="width: 150px"
                              >Phone Number:</label
                              >
                              <input
                                type="text"
                                class="form-control flex-grow-1"
                                formControlName="phone_number"
                                id="phone_number"
                                />
                              </div>
                            </div>

                            <!-- Row 4: Fax and Website -->
                            <div class="row mb-3">
                              <div class="col-md-6 d-flex align-items-center">
                                <label class="form-label me-3" style="width: 150px"
                                  >Fax Number:</label
                                  >
                                  <input
                                    type="text"
                                    class="form-control flex-grow-1"
                                    formControlName="fax_number"
                                    id="fax_number"
                                    />
                                  </div>
                                  <div class="col-md-6 d-flex align-items-center">
                                    <label class="form-label me-3" style="width: 150px"
                                      >Website:</label
                                      >
                                      <input
                                        type="text"
                                        class="form-control flex-grow-1"
                                        formControlName="website"
                                        id="website"
                                        />
                                      </div>
                                    </div>

                                    <!-- Row 5: Name on Checks and Other -->
                                    <div class="row mb-0">
                                      <div class="col-md-6 d-flex align-items-center">
                                        <label class="form-label me-3" style="width: 150px"
                                          >Print on Checks:</label
                                          >
                                          <input
                                            type="text"
                                            class="form-control flex-grow-1"
                                            formControlName="name_to_print_on_checks"
                                            id="name_to_print_on_checks"
                                            />
                                          </div>
                                          <div class="col-md-6 d-flex align-items-center">
                                            <label class="form-label me-3" style="width: 150px"
                                              >Other Identifiers:</label
                                              >
                                              <input
                                                type="text"
                                                class="form-control flex-grow-1"
                                                formControlName="other"
                                                id="other"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <!-- Address Section -->
                                      <div class="section-card">
                                        <div
                                          class="section-header"
                                          (click)="addressIsCollapsed = !addressIsCollapsed"
                                          >
                                          <div class="section-title">
                                            <i class="fa-solid fa-location-dot"></i>
                                            Address Information
                                          </div>
                                          <div class="toggle-icon">
                                            <i
                                              class="fa-solid"
            [ngClass]="
              addressIsCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'
            "
                                            ></i>
                                          </div>
                                        </div>
                                        <div [collapse]="addressIsCollapsed">
                                          <div class="section-body">
                                            <div class="row mb-3">
                                              <div class="col-md-6 d-flex align-items-center">
                                                <label class="form-label me-3" style="width: 150px"
                                                  >Street:</label
                                                  >
                                                  <input
                                                    type="text"
                                                    class="form-control flex-grow-1"
                                                    formControlName="street"
                                                    id="street"
                                                    />
                                                  </div>
                                                  <div class="col-md-6 d-flex align-items-center">
                                                    <label class="form-label me-3" style="width: 150px"
                                                      >Apartment/Suite:</label
                                                      >
                                                      <input
                                                        type="text"
                                                        class="form-control flex-grow-1"
                                                        formControlName="street2"
                                                        id="street2"
                                                        />
                                                      </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                      <div class="col-md-6 d-flex align-items-center">
                                                        <label class="form-label me-3" style="width: 150px">City:</label>
                                                        <ng-select
                                                          [items]="distinct_cities"
                                                          [addTag]="true"
                                                          (addTag)="onCityAddTag($event)"
                                                          class="form-control flex-grow-1"
                                                          formControlName="city"
                                                          id="city"
                                                        ></ng-select>
                                                      </div>
                                                      <div class="col-md-6 d-flex align-items-center">
                                                        <label class="form-label me-3" style="width: 150px">State:</label>
                                                        <input
                                                          type="text"
                                                          class="form-control flex-grow-1"
                                                          formControlName="state"
                                                          id="state"
                                                          />
                                                        </div>
                                                      </div>
                                                      <div class="row mb-0">
                                                        <div class="col-md-6 d-flex align-items-center">
                                                          <label class="form-label me-3" style="width: 150px"
                                                            >Zip Code:</label
                                                            >
                                                            <input
                                                              type="text"
                                                              class="form-control flex-grow-1"
                                                              formControlName="zip_code"
                                                              id="zip_code"
                                                              (input)="findStateAndCity()"
                                                              />
                                                            </div>
                                                            <div class="col-md-6 d-flex align-items-center">
                                                              <label class="form-label me-3" style="width: 150px"
                                                                >Country:</label
                                                                >
                                                                <input
                                                                  type="text"
                                                                  class="form-control flex-grow-1"
                                                                  formControlName="country"
                                                                  id="country"
                                                                  />
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <!-- FFL Section (Vendors Only) -->
                                                        @if (contact_type === "Vendor") {
                                                          <div class="section-card">
                                                            <div class="section-header" (click)="fflIsCollapsed = !fflIsCollapsed">
                                                              <div class="section-title">
                                                                <i class="fa-solid fa-certificate"></i>
                                                                FFL Details
                                                              </div>
                                                              <div class="toggle-icon">
                                                                <i
                                                                  class="fa-solid"
              [ngClass]="
                fflIsCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'
              "
                                                                ></i>
                                                              </div>
                                                            </div>
                                                            <div [collapse]="fflIsCollapsed">
                                                              <div class="section-body">
                                                                <div class="row mb-3">
                                                                  <div class="col-md-6 d-flex align-items-center">
                                                                    <label class="form-label me-3" style="width: 150px"
                                                                      >FFL ID:</label
                                                                      >
                                                                      <input
                                                                        type="text"
                                                                        class="form-control flex-grow-1"
                                                                        formControlName="ffl"
                                                                        id="ffl"
                                                                        autocomplete="one-time-code"
                                                                        [dropSpecialCharacters]="false"
                                                                        mask="0-00-000-00-0A-00000"
                                                                        (input)="verifyFFL()"
                                                                        />
                                                                      </div>
                                                                      <div class="col-md-6 d-flex align-items-center">
                                                                        <label class="form-label me-3" style="width: 150px"
                                                                          >Expiration:</label
                                                                          >
                                                                          <input
                                                                            type="text"
                                                                            class="form-control flex-grow-1"
                                                                            formControlName="expiration_date"
                                                                            id="expiration_date"
                                                                            autocomplete="one-time-code"
                                                                            />
                                                                          </div>
                                                                        </div>
                                                                        <div class="row mb-3">
                                                                          <div class="col-md-6 d-flex align-items-center">
                                                                            <label class="form-label me-3" style="width: 150px">
                                                                              @if (
                                                                                add_edit_contact_form.get("legal_name").hasError("required")
                                                                                ) {
                                                                                <span class="text-danger me-1">*</span>
                                                                              }
                                                                              Legal Name:
                                                                            </label>
                                                                            <input
                                                                              type="text"
                                                                              class="form-control flex-grow-1"
                                                                              formControlName="legal_name"
                                                                              id="legal_name"
                                                                              autocomplete="one-time-code"
                                                                              />
                                                                            </div>
                                                                            <div class="col-md-6 d-flex align-items-center">
                                                                              <label class="form-label me-3" style="width: 150px"
                                                                                >Business Name:</label
                                                                                >
                                                                                <input
                                                                                  type="text"
                                                                                  class="form-control flex-grow-1"
                                                                                  formControlName="business_name"
                                                                                  id="business_name"
                                                                                  autocomplete="one-time-code"
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                              <div class="row mb-3">
                                                                                <div class="col-md-6 d-flex align-items-center">
                                                                                  <label class="form-label me-3" style="width: 150px"
                                                                                    >Phone:</label
                                                                                    >
                                                                                    <input
                                                                                      type="text"
                                                                                      class="form-control flex-grow-1"
                                                                                      formControlName="ffl_phone_number"
                                                                                      id="ffl_phone_number"
                                                                                      autocomplete="one-time-code"
                                                                                      />
                                                                                    </div>
                                                                                    <div class="col-md-6 d-flex align-items-center">
                                                                                      <label class="form-label me-3" style="width: 150px">
                                                                                        @if (
                                                                                          add_edit_contact_form.get("ffl_email").hasError("required")
                                                                                          ) {
                                                                                          <span class="text-danger me-1">*</span>
                                                                                        }
                                                                                        Email:
                                                                                      </label>
                                                                                      <input
                                                                                        type="text"
                                                                                        class="form-control flex-grow-1"
                                                                                        formControlName="ffl_email"
                                                                                        id="ffl_email"
                                                                                        autocomplete="one-time-code"
                                                                                        />
                                                                                      </div>
                                                                                    </div>
                                                                                    <div class="row mb-0">
                                                                                      <div class="col-md-6 d-flex align-items-start">
                                                                                        <label class="form-label me-3 mt-2" style="width: 150px"
                                                                                          >Notes:</label
                                                                                          >
                                                                                          <textarea
                                                                                            class="form-control flex-grow-1"
                                                                                            formControlName="notes"
                                                                                            id="notes"
                                                                                            rows="3"
                                                                                          ></textarea>
                                                                                        </div>
                                                                                        <div
                                                                                          class="col-md-6 d-flex align-items-center justify-content-center"
                                                                                          >
                                                                                          <div class="form-check form-switch custom-switch">
                                                                                            <input
                                                                                              class="form-check-input"
                                                                                              type="checkbox"
                                                                                              role="switch"
                                                                                              id="flexSwitchCheckChecked"
                                                                                              (click)="addFflToggleSwitch()"
                                                                                              />
                                                                                              <label
                                                                                                class="form-check-label ms-2"
                                                                                                for="flexSwitchCheckChecked"
                                                                                                >
                                                                                                {{
                                                                                                addFfl
                                                                                                ? "Add to FFL Quick Selection"
                                                                                                : "Don't add to FFL Quick Selection"
                                                                                                }}
                                                                                              </label>
                                                                                            </div>
                                                                                          </div>
                                                                                        </div>
                                                                                      </div>
                                                                                    </div>
                                                                                  </div>
                                                                                }

                                                                                <!-- Other Section -->
                                                                                <div class="section-card">
                                                                                  <div
                                                                                    class="section-header"
                                                                                    (click)="otherIsCollapsed = !otherIsCollapsed"
                                                                                    >
                                                                                    <div class="section-title">
                                                                                      <i class="fa-solid fa-list-ul"></i>
                                                                                      Other Information
                                                                                    </div>
                                                                                    <div class="toggle-icon">
                                                                                      <i
                                                                                        class="fa-solid"
            [ngClass]="
              otherIsCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'
            "
                                                                                      ></i>
                                                                                    </div>
                                                                                  </div>
                                                                                  <div [collapse]="otherIsCollapsed">
                                                                                    <div class="section-body">
                                                                                      <div class="row mb-3">
                                                                                        @if (this.contact_type === "Customer") {
                                                                                          <div class="col-md-12 d-flex align-items-center mb-3">
                                                                                            <label class="form-label me-3" style="width: 150px">
                                                                                              <span class="text-danger me-1">*</span>Tax Option:
                                                                                            </label>
                                                                                            <ng-select
                                                                                              [items]="sales_tax_options"
                                                                                              [multiple]="false"
                                                                                              [closeOnSelect]="true"
                                                                                              [searchable]="false"
                                                                                              appendTo="body"
                                                                                              class="form-control flex-grow-1"
                                                                                              formControlName="tax_option"
                                                                                              id="tax_option"
                                                                                            ></ng-select>
                                                                                          </div>
                                                                                        }
                                                                                      </div>
                                                                                      <div class="row mb-0">
                                                                                        <div class="col-md-12 d-flex align-items-start">
                                                                                          <label class="form-label me-3 mt-2" style="width: 150px"
                                                                                            >Memo:</label
                                                                                            >
                                                                                            <textarea
                                                                                              class="form-control flex-grow-1"
                                                                                              formControlName="memo"
                                                                                              id="memo"
                                                                                              rows="3"
                                                                                            ></textarea>
                                                                                          </div>
                                                                                        </div>
                                                                                      </div>
                                                                                    </div>
                                                                                  </div>
                                                                                </div>

                                                                                <!--Footer-->
                                                                                <div class="modal-footer">
                                                                                  <div class="required-indicator me-auto">
                                                                                    <span class="text-danger">*</span> <span> denotes required fields</span>
                                                                                  </div>
                                                                                  <button
                                                                                    type="button"
                                                                                    class="btn modern-btn primary-btn"
                                                                                    style="min-width: 180px"
                                                                                    [class.disabled]="add_edit_contact_form.invalid"
                                                                                    (click)="attemptSave()"
                                                                                    >
                                                                                    {{ modal_type }} {{ contact_type }}
                                                                                  </button>
                                                                                  <button
                                                                                    type="button"
                                                                                    class="btn modern-btn secondary-btn"
                                                                                    (click)="closeModalClick()"
                                                                                    >
                                                                                    Cancel
                                                                                  </button>
                                                                                </div>
                                                                              </form>

